<div class="min-h-[calc(100vh-12rem)] flex flex-col items-center justify-center text-center px-4">
  <div class="max-w-2xl mx-auto backdrop-blur-xl bg-white/30 p-8 rounded-2xl border border-white/50 shadow-lg">
    <div class="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-red-300 to-red-600 rounded-2xl shadow-lg flex items-center justify-center">
      <i class="pi pi-ban text-2xl text-white"></i>
    </div>

    <h1 class="text-4xl font-bold text-slate-800 mb-4">
      403 - Zabranjen pristup
    </h1>

    <p class="text-lg text-slate-600 mb-8">
      Nemate dozvolu za pristup ovoj stranici. Molimo prijavite se s odgovarajućim računom.
    </p>

    <div class="flex flex-col sm:flex-row gap-4 justify-center">
      <a
        (click)="login()"
        class="p-button p-component bg-gradient-to-br from-primary-300 to-primary-600 text-white font-semibold px-6 py-2 rounded-lg hover:opacity-90 transition-opacity"
      >
        <i class="pi pi-sign-in mr-2"></i>
        Prijava
      </a>
      <a
        routerLink="/"
        class="p-button p-component p-button-outlined text-slate-700 font-semibold px-6 py-2 rounded-lg hover:bg-slate-50 transition-colors"
      >
        Povratak na početnu
      </a>
    </div>
  </div>
</div>
